// CORE
import React, { Component } from 'react'

// COMPONENTS
import Footer from '../../components/UI/Footer/Footer'

// STYLES
import classes from './Layout.css'

const Aux = (props) => props.children

class Layout extends Component {
	render () {
		return (
			<Aux className={classes.Container}>
				<main>
					{this.props.children}
				</main>
				<Footer />
			</Aux>
		)
	}
}

export default Layout


// WEBPACK FOOTER //
// ./src/hoc/Layout/Layout.js